var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 332,
    viewBox: "0 0 266 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20481e-05 90.0002V295C-0.00523379 299.768 0.929227 304.491 2.74999 308.898C4.57076 313.305 7.24212 317.31 10.6114 320.683C13.9807 324.057 17.9819 326.734 22.3863 328.561C26.7906 330.388 31.5118 331.329 36.28 331.33H228.83C233.597 331.332 238.318 330.394 242.723 328.57C247.128 326.746 251.13 324.072 254.501 320.701C257.872 317.33 260.546 313.328 262.37 308.923C264.193 304.518 265.131 299.798 265.13 295.03V36.3303C265.131 31.5629 264.193 26.842 262.37 22.4373C260.546 18.0326 257.872 14.0304 254.501 10.6594C251.13 7.28834 247.128 4.61455 242.723 2.79077C238.318 0.966992 233.597 0.028961 228.83 0.0302748H90.01L18.83 71.1603L2.20481e-05 90.0002Z",
    fill: "#F7F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.9998L18.83 71.1598L90 0.009767H228.83C233.597 0.00845314 238.318 0.946485 242.723 2.77027C247.128 4.59405 251.13 7.26783 254.501 10.6389C257.872 14.0099 260.546 18.0121 262.37 22.4168C264.193 26.8215 265.131 31.5424 265.13 36.3098V120.67H0V89.9998Z",
    fill: "#EEB443"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.9901L44.43 99.8101C49.0992 100.774 53.9125 100.808 58.595 99.9117C63.2775 99.0151 67.7376 97.2048 71.7204 94.5842C75.7032 91.9637 79.1308 88.5842 81.8074 84.6389C84.484 80.6935 86.3572 76.2595 87.32 71.5901L89.18 61.4102C88.5907 64.2176 87.6569 66.9415 86.4 69.5201C83.4285 75.6576 78.7874 80.8333 73.009 84.4538C67.2307 88.0743 60.5489 89.9931 53.73 89.9901H0Z",
    fill: "#D7D7D7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 89.99H53.73C60.5489 89.993 67.2307 88.0742 73.009 84.4537C78.7874 80.8331 83.4285 75.6574 86.4 69.52C88.7704 64.5792 90.004 59.1701 90.01 53.69V0L18.83 71.16L0 89.99Z",
    fill: "#EFEFEF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.42 264.37H65.6797V272.01H199.42V264.37Z",
    fill: "#EEB443"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.551 272.01C112.636 272.062 93.4807 264.372 79.13 250.564C64.7793 236.756 56.3566 217.912 55.6406 198.01L63.2706 197.71C63.9174 215.651 71.4991 232.641 84.42 245.104C97.3409 257.568 114.593 264.533 132.546 264.533C150.498 264.533 167.75 257.568 180.671 245.104C193.592 232.641 201.174 215.651 201.821 197.71L209.461 198.01C208.745 217.912 200.322 236.756 185.971 250.564C171.621 264.372 152.465 272.062 132.551 272.01Z",
    fill: "#EEB443"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.032 258.1H124.852V278.28H145.032V258.1Z",
    fill: "#EEB443"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.142 279.4H123.742V256.99H146.142V279.4ZM125.962 277.17H143.962V259.17H125.962V277.17Z",
    fill: "#EEB443"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5394 187.73H49.3594V207.91H69.5394V187.73Z",
    fill: "#EEB443"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.66 209.02H48.25V186.61H70.66V209.02ZM50.47 206.8H68.47V188.8H50.47V206.8Z",
    fill: "#EEB443"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M215.731 187.73H195.551V207.91H215.731V187.73Z",
    fill: "#EEB443"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M216.83 209.02H194.43V186.61H216.83V209.02ZM196.65 206.8H214.65V188.8H196.65V206.8Z",
    fill: "#EEB443"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEps);
export default __webpack_public_path__ + "static/media/eps.9504b58f63531fb7fa272cf399dbc473.svg";
export { ForwardRef as ReactComponent };